
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "MilitarIndex",
        components: {    },  
    }) 
    export default class MilitarIndex extends Vue {
         
    }
  
